import * as React from 'react';

import './map.marker.style.scss';

import MapPopup from '../popup';

import type { MapMarkerProps } from './map.marker.props';

const MapMarker: React.FC<MapMarkerProps> = function(props) {
  const {
          active,
          selected,
          ...rest
        } = props;

  return (
    <div className={`map-marker${active ? ' active' : ''}`}>
      <svg
        fill={'none'}
        height={20}
        viewBox={'0 0 16 20'}
        width={16}
        xmlns={'http://www.w3.org/2000/svg'}
      >
        <path
          clipRule={'evenodd'}
          d={'M7.96265 11.292C6.45365 11.292 5.22567 10.065 5.22567 8.556C5.22567 7.047 6.45365 5.819 7.96265 5.819C9.47165 5.819 10.6986 7.047 10.6986 8.556C10.6986 10.065 9.47165 11.292 7.96265 11.292ZM13.5766 2.449C12.0456 0.87 10.0516 0 7.96265 0C5.87165 0 3.87767 0.87 2.34567 2.45C0.790666 4.054 -0.0633338 6.209 0.00366619 8.363C0.192666 14.467 7.38265 19.22 7.68965 19.419L7.95865 19.594L8.23065 19.422C8.53665 19.228 15.7316 14.59 15.9216 8.362C15.9876 6.209 15.1326 4.053 13.5766 2.449Z'}
          fillRule={'evenodd'}
          fill={'black'}
        />
      </svg>
      {selected && <MapPopup {...rest} />}
    </div>
  );
};

export default MapMarker;